import type Phaser from 'phaser';
import { flyWinningChips } from './winningsFly.js';

export interface FlyChipFromSourceOpts {
  scene: Phaser.Scene;
  /** Where on the screen the chip starts (e.g. selected rack chip, bankroll pill). */
  sourceAnchor: { x: number; y: number };
  /** Where on the table the chip lands. */
  tableAnchor: { x: number; y: number };
  cents: number;
  chipRadius?: number;
  dpr?: number;
}

export interface FlyChipToRackOpts {
  scene: Phaser.Scene;
  /** Chip-rack slot anchor in viewport coords (typically the slot for the
   *  bet's denomination so the chip "returns to its slot"). */
  rackAnchor: { x: number; y: number };
  /** Where on the table the chip starts. */
  tableAnchor: { x: number; y: number };
  cents: number;
  chipRadius?: number;
  dpr?: number;
}

const FLY_DURATION_MS = 60;
const FLY_DEPTH = 100;

/** Source → table. Snaps a single transient chip into a bet zone on placement. */
export function flyChipFromSource(opts: FlyChipFromSourceOpts): Promise<void> {
  return flyWinningChips({
    scene: opts.scene,
    from: opts.sourceAnchor,
    to: opts.tableAnchor,
    cents: opts.cents,
    ...(opts.chipRadius !== undefined ? { chipRadius: opts.chipRadius } : {}),
    ...(opts.dpr !== undefined ? { dpr: opts.dpr } : {}),
    durationMs: FLY_DURATION_MS,
    depth: FLY_DEPTH,
  });
}

/** Table → chip rack. Snaps a single transient chip back into the rack slot
 *  matching the bet's denomination — bankroll changes still propagate via
 *  the engine event, but the chip returning to the rack reads more like
 *  "you got your chip back" than flying it into the bankroll pill. */
export function flyChipToRack(opts: FlyChipToRackOpts): Promise<void> {
  return flyWinningChips({
    scene: opts.scene,
    from: opts.tableAnchor,
    to: opts.rackAnchor,
    cents: opts.cents,
    ...(opts.chipRadius !== undefined ? { chipRadius: opts.chipRadius } : {}),
    ...(opts.dpr !== undefined ? { dpr: opts.dpr } : {}),
    durationMs: FLY_DURATION_MS,
    depth: FLY_DEPTH,
  });
}
